import colors from "../../styles/colors";
import { COLORS } from "../../styles/uiConstants";

export const INPUT_MIN_HEIGHT = 44;

export const formInputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    bgcolor: COLORS.white,
    minHeight: INPUT_MIN_HEIGHT,
    "& fieldset": { borderColor: COLORS.slate300, borderWidth: 1 },
    "&:hover fieldset": { borderColor: COLORS.slate400 },
    "&.Mui-focused fieldset": { borderColor: colors.primary, borderWidth: 2 },
  },
  "& .MuiInputLabel-root": {
    fontWeight: 600,
    color: COLORS.slate600,
  },
  // variant="standard" (drawer / detay) — alt çizgi + odak rengi
  "& .MuiInput-underline:before": { borderBottomColor: COLORS.slate300 },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": { borderBottomColor: COLORS.slate400 },
  "& .MuiInput-underline:after": { borderBottomColor: colors.primary },
  "& .MuiInputLabel-root.Mui-focused": { color: colors.primary },
};

export function themedFormInputSx(palette) {
  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      bgcolor: COLORS.white,
      minHeight: INPUT_MIN_HEIGHT,
      "& fieldset": { borderColor: COLORS.slate300, borderWidth: 1 },
      "&:hover fieldset": {
        borderColor: palette?.inputBorder || COLORS.slate400,
      },
      "&.Mui-focused fieldset": {
        borderColor: palette?.primary || colors.primary,
        borderWidth: 2,
      },
    },
    "& .MuiInputLabel-root": {
      fontWeight: 600,
      color: COLORS.slate600,
    },
    // variant="standard" (drawer / detay) — alt çizgi + klinik rengiyle odak
    "& .MuiInput-underline:before": { borderBottomColor: COLORS.slate300 },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: palette?.inputBorder || COLORS.slate400,
    },
    "& .MuiInput-underline:after": { borderBottomColor: palette?.primary || colors.primary },
    "& .MuiInputLabel-root.Mui-focused": { color: palette?.primary || colors.primary },
  };
}

export const formButtonSx = {
  minHeight: INPUT_MIN_HEIGHT,
  boxSizing: "border-box",
};

export default formInputSx;
